import { OriginInfo } from "@/types";

export const isOriginHub = (origin: string, listOfOrigins: Map<string, OriginInfo>): boolean => {
    const originInfo = listOfOrigins.get(origin);
    if (!originInfo) {
        return false;
    }
    
    // Check if any entry in the map has this origin as its parent
    for (const [, info] of listOfOrigins) {
        if (info.parent === origin) {
            return true; // Found a child, so it's a hub without children
        }
    }
    
    return false; // No children found, so it's a hub without children
}